module.exports = __webpack_public_path__ + "media/img/pages/companies/zhaw_lsfm-169226ce1799f77018b054372879b2e8.png";